export const cost = 10;



// WEBPACK FOOTER //
// ./src/custom/livres/EssayCost.js